'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRemoveShoppingCart = function MdRemoveShoppingCart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 30c1.8 0 3.4 1.6 3.4 3.4s-1.6 3.2-3.4 3.2-3.2-1.4-3.2-3.2 1.4-3.4 3.2-3.4z m14.3-8.4l-15-15h22.5c0.9 0 1.6 0.8 1.6 1.8 0 0.3-0.1 0.5-0.2 0.7l-6 10.8c-0.5 1-1.6 1.7-2.9 1.7z m-13.6 3.4h8.5l-3.4-3.4h-3.9l-1.5 2.8 0 0.2c0 0.2 0.1 0.4 0.3 0.4z m25.6 12.9l-2.1 2.1-4.8-4.8c-0.6 0.9-1.5 1.4-2.6 1.4-1.8 0-3.4-1.4-3.4-3.2 0-1.1 0.5-2.1 1.4-2.8l-2.3-2.2h-12.5c-1.8 0-3.2-1.6-3.2-3.4 0-0.5 0.1-1.1 0.3-1.6l2.3-4.1-3.7-7.7-7.3-7.4 2.1-2.1z' })
        )
    );
};

exports.default = MdRemoveShoppingCart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/remove-shopping-cart.js
// module id = 3461
// module chunks = 0